import api from "./base-api"

const CampaignApi = api.injectEndpoints({
    endpoints: (build) => ({
        getAnalytics: build.query({
            query: (data) => {
                return {
                    url: `/admin/analytics/campaign?id=${data}`,
                }
            },
            providesTags: ['Campaign']
        }),
        getAllCampaigns: build.query({
            query: (data) => {
                return {
                    url: `/admin/campaign/list?status=${data.status}`,
                }
            },
            providesTags: ['Campaign']
        }),
        getCampaign: build.query({
            query: (id) => {
                return {
                    url: `/admin/campaign?id=${id}`,
                    method: "GET",
                }

            },
            providesTags: ['Campaign']
        }),
        updateCampaign: build.mutation({
            query: (data) => {
                return {
                    url: `/admin/campaign`,
                    method: "PUT",
                    body: data
                }

            },
            invalidatesTags: ['Campaign']
        }),
        createCampaign: build.mutation({
            query: (data) => {
                return {
                    url: `/admin/campaign`,
                    method: "POST",
                    body: data
                }
            },
            invalidatesTags: ['Campaign']
        }),
        stopCampaign: build.mutation({
            query: (id) => {
                return {
                    url: `/admin/campaign/cancel?id=`+ id,
                    method: "POST",
                }
            },
            invalidatesTags: ['Campaign']
        }),
        scheduleCampaign: build.mutation({
            query: (id) => {
                return {
                    url: `/admin/campaign/schedule?id=`+ id,
                    method: "POST",
                }
            },
            invalidatesTags: ['Campaign']
        }),

        deleteCampaign: build.mutation({
            query: (id) => {
                return {
                    url: `/admin/campaign/delete?id=`+ id,
                    method: "POST",
                }
            },
            invalidatesTags: ['Campaign']
        }),
    }),
    overrideExisting: false
});

export const {
    useGetAllCampaignsQuery,
    useGetCampaignQuery,
    useGetAnalyticsQuery,
    useUpdateCampaignMutation,
    useCreateCampaignMutation,
    useStopCampaignMutation,
    useDeleteCampaignMutation,
    useScheduleCampaignMutation
} = CampaignApi